import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  Box,
  Typography,
  Paper,
  Divider,
  Modal,
  Link,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { getUserEventsNews } from "../redux/actions/commonAction";
import moment from "moment";
import { Link as RouterLink } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import MahendraOla from "../assets/MahendraOla.jpeg";

const NoticeSection = () => {
  const dispatch = useDispatch();
  const { userEventsNews } = useSelector((state) => state.userEventsNews);
  const [open, setOpen] = useState(false);
  const [selectedNotice, setSelectedNotice] = useState(null);
  const [repeatCount, setRepeatCount] = useState(1);
  const scrollRef = useRef();

  useEffect(() => {
    dispatch(getUserEventsNews());
  }, [dispatch]);

  const handleOpen = (userEventsNews) => {
    setSelectedNotice(userEventsNews);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  useEffect(() => {
    const container = scrollRef.current;
    const scrollSpeed = 0.5;
    let animationFrameId;

    const scroll = () => {
      if (!container) return;

      const maxScrollTop = container.scrollHeight - container.clientHeight;

      if (container.scrollTop >= maxScrollTop - 10) {
        setRepeatCount((prev) => prev + 1); 
      }

      container.scrollTop += scrollSpeed;
      animationFrameId = requestAnimationFrame(scroll);
    };

    if (container) {
      animationFrameId = requestAnimationFrame(scroll);
    }

    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  return (
    <Box
      sx={{
        bgcolor: "#C49A4B",
        color: "#fff",
        p: { xs: 2, md: 6 },
        mt: 5,
        mb: 8,
      }}
    >
      <Grid container spacing={4}>
        {/* Principal's Desk */}
        <Grid item xs={12} md={12} lg={6}>
          <Box
            display="flex"
            flexDirection={{ xs: "column", md: "row" }}
            alignItems="center"
          >
            <Box
              component="img"
              src={MahendraOla}
              alt="Principal"
              sx={{
                border: "2px solid #cfa95f",
                borderRadius: 1,
                width: 350,
                height: 450,
              }}
            />
            <Box ml={{ md: 3 }} mt={{ xs: 3, md: 0 }}>
              <Typography
                variant="h5"
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  color: "#AD1C86",
                  fontWeight: "bold",
                }}
              >
                Principal&apos;s Desk
              </Typography>
              <Typography
                sx={{
                  my: 2,
                  fontSize: 16,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
               It is with great pride and humility that I serve as the Principal of Shree Mangalam School, an institution dedicated to nurturing students who embody knowledge, integrity, creativity, and a deep love for our culture and heritage...
               {/* Our mission is clear: "To empower learners with skills, values, and innovation, while fostering a deep connection to Indian civilization, heritage, and a spirit of service to humanity." */}
              </Typography>
              <Typography fontStyle="italic">
                Mr. Mahendra Ola
              </Typography>
              <Link
                component={RouterLink}
                to="/principal-desk"
                underline="hover"
                sx={{ color: "#065A79", display: "inline-block", mt: 1 }}
              >
                READ MORE →
              </Link>
            </Box>
          </Box>
        </Grid>

        {/* Notice Board */}
        <Grid item xs={12} md={12} lg={6}>
          <Paper
            elevation={3}
            sx={{ bgcolor: "#fff", borderRadius: 2, overflow: "hidden" }}
          >
            <Box sx={{ bgcolor: "#065A79", py: 1, px: 2 }}>
              <Typography variant="h6" color="white">
                NOTICE BOARD
              </Typography>
            </Box>

            <Box
              ref={scrollRef}
              sx={{
                px: 2,
                py: 2,
                maxHeight: 300,
                overflowY: "auto",
                scrollBehavior: "smooth",
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                {[...Array(repeatCount)].map((_, repeatIndex) =>
                  userEventsNews?.map((item, i) => (
                    <Box key={`${repeatIndex}-${i}`} sx={{ mb: 2 }}>
                      <Grid container spacing={2} alignItems="flex-start">
                        <Grid item xs={4}>
                          <Typography
                            variant="caption"
                            fontWeight="bold"
                            sx={{ color: "#0c1b43" }}
                          >
                            {moment(item.startDate).format("YYYY")}
                          </Typography>
                          <Typography
                            variant="h6"
                            sx={{
                              color: "#0c1b43",
                              fontSize: 15,
                              fontFamily: "Montserrat, sans-serif",
                              fontOpticalSizing: "auto",
                              fontStyle: "normal",
                              letterSpacing: 1,
                              lineHeight: "1.8rem",
                            }}
                          >
                            {moment(item.startDate).format("MMMM Do")}
                          </Typography>
                        </Grid>
                        <Grid item xs={8}>
                          <Typography
                            variant="body2"
                            sx={{
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              color: "#0c1b43",
                            }}
                            dangerouslySetInnerHTML={{ __html: item.title }}
                          ></Typography>
                          <Link
                            component="button"
                            underline="hover"
                            sx={{ color: "#cfa95f", fontSize: 13 }}
                            onClick={() => handleOpen(item)}
                          >
                            Read More →
                          </Link>
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 1 }} />
                    </Box>
                  ))
                )}
              </Box>
            </Box>

            <Box sx={{ p: 2 }}>
              <Link
                component={RouterLink}
                to="/news-events"
                underline="hover"
                sx={{ color: "#065A79" }}
              >
                SEE ALL NOTICE →
              </Link>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      {/* Modal for notice details */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            p: 4,
            borderRadius: 2,
            width: { xs: "90%", md: 600 },
            maxHeight: "80vh",
            overflowY: "auto",
            position: "relative",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#065A79",
            }}
          >
            <CloseIcon />
          </IconButton>

          <Typography
            variant="body1"
            sx={{
              mb: 1,
              fontWeight: "bold",
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              letterSpacing: 1,
              color: "#AD1C86",
            }}
          >
            Notice
          </Typography>

          <hr />

          {selectedNotice && (
            <>
              <Typography
                variant="body1"
                sx={{
                  mb: 1,
                  mt: 3,
                  fontWeight: "bold",
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  // color: "#AD1C86",
                }}
                dangerouslySetInnerHTML={{ __html: selectedNotice.title }}
              />
              <Typography
                variant="caption"
                sx={{ mb: 2, display: "block", color: "#AD1C86" }}
              >
                {moment(selectedNotice.startDate).format("MMMM Do")},{" "}
                {moment(selectedNotice.startDate).format("YYYY")} -{" "}
                {moment(selectedNotice.endDate).format("MMMM Do")},{" "}
                {moment(selectedNotice.endDate).format("YYYY")}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#333",
                  mt: 1,
                  fontFamily: "Montserrat, sans-serif",
                  fontSize: "15px",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
                dangerouslySetInnerHTML={{ __html: selectedNotice.description }}
              />
            </>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default NoticeSection;
